var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-description"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name: 'home'}}},[_c('img',{attrs:{"src":"amej-pay.png"}})])],1),_c('div',{staticClass:"description"},[_c('p',[_vm._v(_vm._s(_vm.data.title))]),_c('span',[_vm._v(_vm._s(_vm.data.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }